/* Tap & Key tap demo (premium v3, Oct 2026). Drives sections/tk-tap.liquid. Simulation only: nothing here talks to NFC hardware. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(app) {
    if (app.__tk) return; app.__tk = true;
    var sec = app.closest('section');
    var tabs = [].slice.call(app.querySelectorAll('[data-step-btn]'));
    var pans = [].slice.call(app.querySelectorAll('[role=tabpanel]'));
    var live = app.querySelector('[data-live]');
    var timers = [];
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function later(fn, ms) { timers.push(setTimeout(fn, reduce ? 0 : ms)); }
    function set(k, v) { app.setAttribute('data-' + k, v); }
    function say(t) { if (live) live.textContent = t; }
    function hostOf(i) { var b = app.querySelector('[data-dest-btn="' + i + '"]'); return b ? b.getAttribute('data-host') : ''; }
    function labelOf(i) { var b = app.querySelector('[data-dest-btn="' + i + '"]'); return b ? b.textContent.trim() : ''; }
    function showPage(i) {
      app.querySelectorAll('.tk-mock').forEach(function (m) { m.classList.toggle('is-on', m.getAttribute('data-i') == i); });
      app.querySelectorAll('[data-host]').forEach(function (h) { if (!h.hasAttribute('data-dest-btn')) h.textContent = hostOf(i); });
    }
    function screen(s) { set('screen', s); }
    function step(n, focus) {
      clear(); set('step', n); set('phase', 'idle');
      tabs.forEach(function (t, i) { var on = i + 1 == n; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      pans.forEach(function (p, i) { p.hidden = i + 1 != n; });
      screen(n == 3 ? 'store' : n == 4 ? 'write' : 'home');
      if (n == 4) resetWrite();
    }
    // On narrow screens the stage sits above the controls: bring it into view before animating
    function reveal() {
      var st = app.querySelector('.tk-tap__stage'), r = st.getBoundingClientRect();
      if (r.bottom < 140 || r.top > window.innerHeight - 140) window.scrollTo({ top: window.pageYOffset + r.top - 80, behavior: reduce ? 'auto' : 'smooth' });
    }
    function tap(i, msg, auto) {
      clear(); if (!auto) reveal(); showPage(i); screen('home'); set('phase', 'approach');
      later(function () { set('phase', 'tap'); }, 700);
      later(function () { screen('note'); }, 1300);
      later(function () { screen('page'); set('phase', 'done'); if (!auto || msg) say('Simulation: the phone opened the example link: ' + labelOf(i) + '.' + (msg || '')); }, 2500);
    }
    function resetWrite() {
      var d2 = app.getAttribute('data-dest2');
      app.querySelector('[data-newurl]').textContent = 'https://' + hostOf(d2);
      app.querySelector('[data-wstatus]').textContent = 'Ready to write';
      set('wstate', 'ready');
    }
    function write() {
      clear(); reveal(); resetWrite(); screen('write'); set('phase', 'approach');
      var st = app.querySelector('[data-wstatus]'), d2 = app.getAttribute('data-dest2');
      later(function () { set('phase', 'tap'); set('wstate', 'busy'); st.textContent = 'Hold near the tap spot…'; }, 700);
      later(function () { set('wstate', 'ok'); st.textContent = 'Write complete'; say('Simulation: new link written.'); }, 1900);
      later(function () { set('phase', 'idle'); }, 2600);
      later(function () { set('dest', d2); syncRadios(); tap(d2, ' The next tap opens the new link.', true); }, 3300);
    }
    function syncRadios() {
      var d = app.getAttribute('data-dest'), d2 = app.getAttribute('data-dest2');
      app.querySelectorAll('[data-dest-btn]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-dest-btn') == d); });
      app.querySelectorAll('[data-dest2-btn]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-dest2-btn') == d2); });
    }
    app.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !app.contains(t)) return;
      if (t.hasAttribute('data-step-btn')) return step(+t.getAttribute('data-step-btn'));
      if (t.hasAttribute('data-go')) return step(+t.getAttribute('data-go'), true);
      if (t.hasAttribute('data-product')) {
        var p = t.getAttribute('data-product');
        app.querySelectorAll('[data-product]').forEach(function (b) { b.setAttribute('aria-checked', b === t); });
        app.querySelectorAll('.tk-tap__pimg').forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-i') == p); });
        return say('Showing ' + t.firstChild.textContent.trim() + '.');
      }
      if (t.hasAttribute('data-dest-btn')) { set('dest', t.getAttribute('data-dest-btn')); syncRadios(); return tap(t.getAttribute('data-dest-btn')); }
      if (t.hasAttribute('data-play')) return tap(app.getAttribute('data-dest'));
      if (t.hasAttribute('data-dest2-btn')) { set('dest2', t.getAttribute('data-dest2-btn')); syncRadios(); return resetWrite(); }
      if (t.hasAttribute('data-write')) return write();
    });
    // Arrow keys move between tabs and radios (WAI-ARIA pattern)
    app.addEventListener('keydown', function (e) {
      var t = e.target; if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      var group = t.getAttribute('role') == 'tab' ? tabs : t.getAttribute('role') == 'radio' ? [].slice.call(t.parentNode.querySelectorAll('[role=radio]')) : null;
      if (!group) return; e.preventDefault();
      var i = group.indexOf(t) + (e.key == 'ArrowRight' || e.key == 'ArrowDown' ? 1 : -1);
      var n = group[(i + group.length) % group.length]; n.focus(); n.click();
    });
    showPage(0); syncRadios();
    // First play once the demo scrolls into view (skipped for reduced motion: it shows the opened page instead)
    if (reduce) { screen('page'); return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); if (app.getAttribute('data-step') == '1') later(function () { if (app.getAttribute('data-step') == '1') tap(0, '', true); }, 600); }
      }, { threshold: 0.5 });
      io.observe(app);
    }
  }
  function boot() { document.querySelectorAll('[data-tk-tap]').forEach(init); }
  if (document.readyState != 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
